module.exports = __webpack_public_path__ + "img/img_vs_company.34672fbd.jpg";